import { Component, Injector, OnDestroy } from '@angular/core';

import { NavService } from '@mt-ng2/nav-module';

import { ResetPasswordComponent } from '../separated-portal/reset-password.component';

@Component({
    selector: 'app-reset-password',
    templateUrl: '../separated-portal/reset-password.component.html',
})
export class ResetPasswordOldStyleComponent extends ResetPasswordComponent implements OnDestroy {
    protected navService: NavService;

    constructor(injector: Injector) {
        super(injector);
        this.navService = injector.get(NavService);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.navService.setShowNav(false);
    }

    ngOnDestroy(): void {
        this.navService.setShowNav(true);
    }
}
